import { render, staticRenderFns } from "./RecentPage.vue?vue&type=template&id=215d947c&scoped=true&"
import script from "./RecentPage.vue?vue&type=script&lang=js&"
export * from "./RecentPage.vue?vue&type=script&lang=js&"
import style0 from "./RecentPage.vue?vue&type=style&index=0&id=215d947c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215d947c",
  null
  
)

export default component.exports